<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col>-->
<!--          <router-link :to="{ name: 'EXCMSlaList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>-->
<!--        </b-col>-->
<!--      </b-row>-->
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">{{$t('views.excmdailyplan.create.title')}} {{ today }}</h4>
            </div>
            <div class="card-body">
              <b-row v-if="serviceman">
                <b-col>
                  <p v-if="serviceman.name && serviceman.surname" class="m-0">
                    <b>{{ serviceman.name }} {{ serviceman.surname }}</b>
                  </p>
                  <p v-if="serviceman.mobilePhone" class="m-0"><phoneNumberLink :phoneNumber="serviceman.mobilePhone"/></p>
                  <p v-if="serviceman.userEmail" class="m-0"><a :href="'mailto: ' + serviceman.userEmail">{{ serviceman.userEmail }}</a></p>
                  <p v-if="serviceman.contactEmail" class="m-0"><a :href="'mailto: ' + serviceman.contactEmail">{{ serviceman.contactEmail }}</a></p>
                </b-col>
              </b-row>
<!--              <b-row>-->
<!--                <b-col>-->
<!--                  <EXCMDailyPlanForm-->
<!--                    :handle-submit="onSendForm"-->
<!--                    :handle-update-field="updateField"-->
<!--                    :values="item"-->
<!--                    :errors="violations" />-->
<!--                </b-col>-->
<!--              </b-row>-->
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="today">
        <b-col>
          <div class="card" v-show="tasksQuantity > 0">
            <div class="card-body">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h6 class="mt-2">{{ $t('global.notAssigned') }} ({{ tasksQuantity }})</h6>
                    </b-col>
                    <b-col>
                      <b-btn @click="assignAll()" class="float-right" variant="outline-primary" size="sm">{{ $t('global.assignAll') }}</b-btn>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <TasksTable v-model="tasksQuantity"
                              :iriServiceman="this.$route.params.iriServiceman"
                              :assigned="false"
                              :notAssigned="true"
                              :date="today"></TasksTable>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
// import EXCMDailyPlanForm from './Form'
import TasksTable from '../excmtask/components/TaskLists/TasksTable'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

const { mapGetters, mapActions } = createNamespacedHelpers('excmdailyplan/create')

export default {
  components: {
    PhoneNumberLink,
    TasksTable
    // EXCMDailyPlanForm
  },

  data () {
    return {
      tasksQuantity: -1,
      today: '',
      serviceman: {},
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      this.$router.push({ name: 'EXCMDailyPlanUpdate', params: { id: created['@id'] } })
    }
  },

  created () {
    this.today = this.$moment().format('YYYY-MM-DD')
    this.item.date = this.$moment().format('YYYY-MM-DD')
    this.getServicemanData()
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    assignAll () {
      // console.log()
    },

    getServicemanData () {
      let userDataIri = this.$route.params.iriServiceman
      if (userDataIri) {
        this.item.idServiceman = userDataIri
        this.$http.get(userDataIri)
          .then(response => {
            this.serviceman = response.data
          })
          .catch(error => {
            if (error.response.status === 400) {
              let text = ''
              for (let i in error.response.data) {
                text += error.response.data[i] + '\n'
              }
              this.$Swal({
                type: 'warning',
                title: text,
                timer: 2500
              })
            }
            console.log(error)
          })
      }
    },

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
